import React, { useCallback, useState } from 'react';
import PortfolioMainPanel from './containers/Portfolio-Main-Panel';
import PortfolioDetailPanel from './containers/Portfolio-Detail-Panel';
import { useAppDispatch, useAppSelector } from '../../core/rootHooks';
import { AppDispatch } from '../../core/store';
import { selectSelectedPortfolioWithMsiVessels } from './portfolioSelectors';
import { getPortfolioWithVesselsRequest, setSelectedPortfolioRequest } from './portfolioSlice';
import { isNil } from 'lodash';

export interface IPortfolioProps {
	setActiveLeftSidebarMenu: (value: string) => void;
}

const Portfolio: React.FC<IPortfolioProps> = ({ ...props }) => {
	const [isPortfolioDetailOpen, setIsPortfolioDetailOpen] = useState(false);

	// Get subscribed vessels from redux store
	const dispatch = useAppDispatch<AppDispatch>();
	const selectedPortfolio = useAppSelector(selectSelectedPortfolioWithMsiVessels);

	const handleDisplayPortfolioDetailPanel = useCallback(
		(value: boolean, portfolioId: number | null, tempId?: string, isDraft?: boolean) => {
			if ((portfolioId || tempId) && !isNil(isDraft)) { // || isNil(isDraft)
				dispatch(setSelectedPortfolioRequest({ id: portfolioId, tempId: tempId, isDraft: isDraft }));				
			} else {
				dispatch(getPortfolioWithVesselsRequest({ id: portfolioId, tempId: tempId, isDraft: isDraft }));
			}
			setIsPortfolioDetailOpen(value);
			// dispatch(getPortfolioWithVesselsRequest({ id: portfolioId, tempId: tempId, isDraft: isDraft }));
		},
		[dispatch],
	);

	const handleClosePortfolioDetail = useCallback(() => {
		setIsPortfolioDetailOpen(false);
		dispatch(setSelectedPortfolioRequest({ id: null }));
	}, [dispatch]);

	return (
		<div className="fixed flex flex-row inset-0 bg-black/50 z-10" style={{ top: 64, bottom: 40 }}>
			<div className={`bg-msi-white-color absolute`} style={{ top: 11, left: 88, bottom: 10, width: "300px" }}>
				<PortfolioMainPanel
					displayPortfolioDetailPanel={handleDisplayPortfolioDetailPanel}
					displayPortfolioMainPanel={props.setActiveLeftSidebarMenu}
					key="portfolio-main-panel"
					title="Load Portfolio"
					isDetailOpen={isPortfolioDetailOpen}
					selectedPortfolio={selectedPortfolio}
				/>
			</div>
			{isPortfolioDetailOpen && (
				<div
					className={`bg-msi-white-color ease-in-out duration-300 ${isPortfolioDetailOpen ? 'translate-x-0' : 'translate-x-full'} absolute`}
					style={{ top: 11, left: 388, bottom: 10 }}
				>
					<PortfolioDetailPanel
						key={selectedPortfolio?.id ?? 'add-new-portfolio'}
						portfolioId={selectedPortfolio?.id ?? null}
						closePortfolioDetail={handleClosePortfolioDetail}
						displayPortfolioMainPanel={props.setActiveLeftSidebarMenu}
					/>
				</div>
			)}
		</div>
	);
};

export default Portfolio;


